<section class="report-section reports-tab">
  <!--<div *ngIf="showError" class="alert valign-children-middle">
    <div class="alert-error" role="img" aria-label="Error">
      <i class="icon-badgealert"></i>
    </div>
    <div>
      <span>{{errorMessage}}</span>
    </div>
  </div>-->
  <form [formGroup]="dateRangeForm" autocomplete="off">
  <section class="margin-10">
    <div class="dateRangeHeader"> Foundation account</div>
    <label id="fan">{{fan}} </label>
    <span *ngIf="!singleDevice"><label class="separator">| </label>
    <a href="#" (click)="backToPrevious($event, 'reportType', false)">Change</a></span>
   <!-- <label>Foundation account </label>
    <div>
      <label>{{fan}} | <a href="#" (click)="backToPrevious($event, 'reportType', false)">Change</a></label>
    </div> -->
  </section>

  <section *ngIf="accountType=='singleDevice'" class="margin-10">
    <label>Device </label>
    <div >
      <label>{{selectedCtn}} | <a href="#" (click)="backToPrevious($event, 'reportType', false)">Change</a></label>
    </div>
  </section>
  <p tabindex="0">Choose a date range for your report. The default setting includes the last 90 days of activity.	  </p>
  <div class="dateRangeLabel">
    <label for="dateRange" class="dateRangeHeader">Select date range</label>
  </div>
  <div class="dropdown-section" for="dateRange">
    <app-dropdown [labelId]="'dateRange'" formControlName="dateRange" [placeholderAriaLabel]="'Select date range'" id="dateRange" [options]="dateRanges" [placeholder]="'Select'" (selectEmit)="selectDateRangeOption($event)" [prePopulateValue]="preselectValue" ngDefaultControl></app-dropdown>
  </div>
  <div *ngIf="showDate">
    <div class="select-dates" *ngFor="let field of formInputs">
      <div class="device-header">
        <label>{{field.title}}: {{field.toolTipText}}</label>
      </div>
      <app-date-picker id="{{field.id}}" datePickerHeading="{{field.toolTipText}}" [datePickerInput]="field.dateInput" (updateDate)="onDateChange($event)" [showError]=false></app-date-picker>
      <!--<span *ngIf="field.id === 'from' ? false : dateError" class="error-msg"><i class="icon-badgealert"></i>This cannot be left blank</span>-->
    </div>
  </div>

  <section class="cta row text-right">
    <button (click)="processNext()" href="javascript:void(0)" class="btn btn-secondary pull-right" attr.aria-label="Continue">Continue</button>
   <a href="#" (click)="backToPrevious($event)" class="btn btn-link btn-block btn-cancel">Back</a>
   <!-- <a href="/reports/transaction/reportType" class="btn btn-link btn-block btn-cancel" attr.aria-label="Back">Back</a> -->
  </section>
  </form>
</section>